import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faDesktop, faFileAlt } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss';


function HomeLoggedScreen() {
    const [direct, setDirect] = useState(false);
    const [adm, setAdm] = useState(false);
    const nome = localStorage.getItem('nome');
    
    const redireciona = async () => {
        await getNivel();
    }

    const getNivel = async () => {
        let user = localStorage.getItem('nivel');
        if (user === "Administrador") {
            setAdm(true)
        }
    }

    useEffect(() => {
        redireciona()
    }, [])

    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    } else {
        return (
            <Fragment>
                <Container>
                    <h5>Bem vinda, {nome}, o que deseja fazer?</h5><br />
                    <Row xs={1} lg={4}>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ti/solicitacao')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={1}>
                                                <Col>
                                                    <FontAwesomeIcon className='icon-cad' icon={faFileAlt} />
                                                </Col>
                                                <Col>
                                                    <p className='titulo-home'>Solicitações</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ti/componentes')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={1}>
                                                <Col>
                                                    <FontAwesomeIcon className='icon-cad' icon={faDesktop} />
                                                </Col>
                                                <Col>
                                                    <p className='titulo-home'>Componentes</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        {adm ? 
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ti/user')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={1}>
                                                <Col>
                                                    <FontAwesomeIcon className='icon-cad' icon={faUsers} />
                                                </Col>
                                                <Col>
                                                    <p className='titulo-home'>Usuários</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col> : null}
                    </Row>
                </Container>
            </Fragment>
        );
    }
}

export default HomeLoggedScreen;